/**
 * Maximum number of order entry items to fetch in a single query.
 * This is set high to fetch all items at once for local filtering/sorting.
 */
export const ORDER_ENTRY_ITEMS_LIMIT = 10_000;

export const MAX_CART_QUANTITY = 99_999;

/** Backend keys for the on-hand inventory column; both forms appear depending on the supplier's price-edit display config. */
export const ON_HAND_COLUMN_ID = 'on_hand';
export const ON_HAND_COLUMN_KEYS = new Set([
  ON_HAND_COLUMN_ID,
  'on_hand.on_hand',
]);

export enum ColumnId {
  AddedAt = 'addedAt',
  Brand = 'brand',
  Description = 'description',
  Fulfilled = 'fulfilled',
  GpDollar = 'grossProfitDollar',
  GpPercentage = 'grossProfitPercentage',
  ItemCode = 'itemCode',
  Name = 'name',
  Notes = 'notes',
  PackSize = 'packSize',
  Price = 'price',
  Quantity = 'quantity',
  Unit = 'unit',
}
